import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";


// ---------- Styles ----------
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 11,

    lineHeight: 1.4,
  },
  header: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
    color: "#1D4ED8",
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 4,
    color: "#059669",
  },
  subsection: {
    marginLeft: 10,
    marginBottom: 4,
  },
  listItem: {
    flexDirection: "row",
    marginBottom: 2,
  },
  bullet: {
    width: 10,
  },
  signatureLine: {
    borderBottom: "1pt solid black",
    width: "80%",
    marginTop: 20,
  },
  italic: {
    fontStyle: "italic",
    fontSize: 10,
    color: "#6B7280",
  },
  inputField: {
    marginBottom: 2,
  },
});

// ---------- Helper to render lists ----------
const RenderList = ({ items }) =>
  items?.length ? (
    items.map((item, idx) => (
      <View key={idx} style={styles.listItem}>
        <Text style={styles.bullet}>•</Text>
        <Text>{item}</Text>
      </View>
    ))
  ) : (
    <Text style={styles.italic}>No entries yet.</Text>
  );

// ---------- Main PDF Component ----------
const CarePlanPDFView = ({ data }) => {
  if (!data) return null;

  return (
    <Document>
      <Page style={styles.page} size="A4">
        {/* Header */}
        <Text style={styles.header}>PATIENT-CENTERED CARE PLAN</Text>

        {/* Patient Info */}
        <Text style={styles.sectionTitle}>Patient Info</Text>
        <Text style={styles.inputField}>Name: {data.patientName || "N/A"}</Text>
        <Text style={styles.inputField}>Date: {data.date || "N/A"}</Text>
        <Text style={styles.inputField}>Provider: {data.providerName || "N/A"}</Text>

        {/* Sections */}
        {[
          { title: "Top Concerns", key: "healthConcerns" },
          { title: "Health Barriers", key: "healthBarriers" },
          { title: "Symptoms", key: "symptoms" },
          { title: "Health Care Providers", key: "otherProviders" },
          { title: "Resources and Supports", key: "supportResources" },
          { title: "Medications", key: "medications" },
          { title: "Allergies", key: "allergies" },
          { title: "Conditions", key: "conditions" },
          { title: "Treatment Goals/Targets", key: "treatmentGoals" },
          { title: "Expected Outcomes/Prognosis", key: "expectedOutcomes" },
        ].map((section) => (
          <View key={section.key}>
            <Text style={styles.sectionTitle}>{section.title}</Text>
            <RenderList items={data[section.key]} />
          </View>
        ))}

        {/* Nested Summary */}
        {data.summary && (
          <View>
            <Text style={styles.sectionTitle}>Summary of Things I Need to Do</Text>
            {[
              "tests",
              "professionals",
              "communityResources",
              "medChanges",
              "treatments",
              "education",
              "activities",
            ].map((key) => (
              <View key={key} style={styles.subsection}>
                <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </Text>
                <RenderList items={data.summary[key]} />
              </View>
            ))}
          </View>
        )}

        {/* Lifestyle Changes */}
        {data.lifestyleChanges && (
          <View>
            <Text style={styles.sectionTitle}>Lifestyle Changes</Text>
            {Object.keys(data.lifestyleChanges).map((key) => (
              <View key={key} style={styles.subsection}>
                <Text style={{ fontWeight: "bold", marginBottom: 2 }}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </Text>
                <RenderList items={data.lifestyleChanges[key]} />
              </View>
            ))}
          </View>
        )}

        {/* Care Manager */}
        {data.careManager && (
          <View>
            <Text style={styles.sectionTitle}>Care Manager</Text>
            <Text>Name: {data.careManager.name || "N/A"}</Text>
            <Text>Contact: {data.careManager.contact || "N/A"}</Text>
          </View>
        )}

        {/* Appointment Frequency */}
        <View>
          <Text style={styles.sectionTitle}>Frequency of Planned Future Appointments</Text>
          <Text>{data.appointmentFrequency || "N/A"}</Text>
        </View>

        {/* Signatures */}
      {/* Signatures */}
<View style={{ marginTop: 20, display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
  <View style={{ width: "45%" }}>
    <Text style={{ fontWeight: "bold" }}>Patient Signature:</Text>
    <Text>{data?.patientSignature || "____________________"}</Text>
  </View>
  <View style={{ width: "45%" }}>
    <Text style={{ fontWeight: "bold" }}>Provider Signature:</Text>
    <Text>{data?.providerSignature || "____________________"}</Text>
  </View>
</View>


        {/* Footer */}
        <Text style={[styles.italic, { textAlign: "center", marginTop: 10 }]}>
          Developed by Kenneth G. Adler, MD, MMM...
        </Text>
      </Page>
    </Document>
  );
};

export default CarePlanPDFView;
